<shared-circle-counter class="tile-for-loyalty-points-counter" [size]="size" [current]="currCount">
    <ng-container *ngIf="!!loyaltyPoints">
            <div class="tile-for-loyalty-points-counter__hd">
                <ng-container *ngIf="loyaltyPoints?.mode === 0">
                    {{ loyaltyPoints?.memberPoints | number: '1.0-' + loyaltyPoints?.roundUnits }}
                </ng-container>
                <ng-container *ngIf="loyaltyPoints?.mode === 1">
                    ${{ loyaltyPoints?.dolarPoints | number: '1.0-' + loyaltyPoints?.roundUnits }}
                </ng-container>
            </div>
            <div class="tile-for-loyalty-points-counter__subhd">{{ loyaltyPoints?.circleHeader }}</div>
    </ng-container>
    <shared-loader-for-spinner *ngIf="!loyaltyPoints"
        class="tile-for-loyalty-points-counter__loader"></shared-loader-for-spinner>
</shared-circle-counter>